module.exports = "//cdn-deploy.cdn.bcebos.com/muses_plt/static/img/4.3-create-vote.36ef4255.png";